import { Trans } from '@lingui/react/macro';

import { DefectCard } from '@/components/DefectsList/DefectCard/DefectCard';
import FoldableSection from '@/design_system/FoldableSection';
import Stack from '@/design_system/Stack';
import { computeDuplicateDefectNumber } from '@/models/defectType';
import { useArticleContext } from '@/routes/Requests/contexts/ArticleContext';

import { ConditionFormQuestion, getSubQuestion } from './ConditionQuestion';

export const AssociatedDefects = ({ question }: { question: ConditionFormQuestion }) => {
  const { article, initialConditionFormData } = useArticleContext();

  const editableArticleConditionForm = initialConditionFormData?.articleConditionForms.find(
    (articleConditionForm) => !articleConditionForm.completedAt
  );

  const subQuestion = getSubQuestion({
    question,
    articleConditionForm: editableArticleConditionForm,
  });

  const articleConditions = editableArticleConditionForm?.articleConditions.filter(
    (articleCondition) =>
      articleCondition.questionId === question.id ||
      (!!subQuestion && articleCondition.questionId === subQuestion.id)
  );

  const associatedDefects = article.snapshot.articleDefects.filter((defect) =>
    articleConditions?.some((articleCondition) => articleCondition.id === defect.articleConditionId)
  );

  if (associatedDefects.length === 0) {
    return null;
  }

  return (
    <Stack
      padding="12px"
      className="bg-neutral-100"
      style={{
        borderBottomLeftRadius: '8px',
        borderBottomRightRadius: '8px',
      }}
    >
      <FoldableSection
        size="small"
        startClosed={false}
        label={
          <span className="label-100-medium">
            <Trans id="requests.new.articles.drawer.conditions-form.associated-defects.label">
              Associated defects
            </Trans>
          </span>
        }
      >
        <Stack gap="0.5rem" padding="8px 0 0">
          {associatedDefects.map((defect) => (
            <DefectCard
              key={defect.id}
              defect={defect}
              duplicateDefectNumber={computeDuplicateDefectNumber(
                defect,
                article.snapshot.articleDefects
              )}
            />
          ))}
        </Stack>
      </FoldableSection>
    </Stack>
  );
};
